const Actions = {
  LOGIN: "GET_LOGIN",
  SIGN_UP: "GET_LOGIN",
  INVITE_FRIEND: "INVITE_FRIEND",
  CONTACT_US: "CONTACT_US",
};

export default Actions;
